import { gql } from '__generated__'

export const GetCandidateEmailAudits = gql(/* GraphQL */ `
    query GetCandidateEmailAudits($candidateId: String!) {
        candidateEmailAudits(candidateId: $candidateId) {
            id
            candidateId
            recipientEmail
            emailType
            subject
            senderEmail
            senderName
            bodyPlain
            bodyHtml
            sent
            createdAt
        }
    }
`)
